import React from "react";
import ErrorLayer from "../components/ErrorLayer";


const ErrorPage = () => {
  return (
    <>
      {/* MasterLayout */}
     


        {/* ErrorLayer */}
        <ErrorLayer />


    </>
  );
};

export default ErrorPage;
